import React from "react";
import "./dropdown-icon-header.sass";
import TintIcon from "../../../icon/icon";
export const DropdownIconHeader = ({ iconCenter, iconSvgUrl }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "tint-dropdown-icon-header" }, iconCenter && /* @__PURE__ */ React.createElement(TintIcon, { icon: iconCenter, "data-testid": "tint-dropdown-icon-header" }), iconSvgUrl && /* @__PURE__ */ React.createElement(TintIcon, { iconSvgUrl, "data-testid": "tint-dropdown-icon-header" }));
};
